import { render } from "./PaymentInfo.vue?vue&type=template&id=6065b7bf&scoped=true&ts=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts"

import "./PaymentInfo.vue?vue&type=style&index=0&id=6065b7bf&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6065b7bf"]])

export default __exports__